import {
  Box,
  Button,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const HomeExports = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        py: { xs: 4, md: 10 },
        px: { xs: 2, sm: 4, md: 12 },
        mt: { xs: "40px", md: "94px" }, // Adjust margin-top for mobile
        backgroundColor: "#e6eedb",
      }}
    >
      <Grid container spacing={6} alignItems="center">
        {/* TEXT COLUMN */}
        <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
          <Box>
            <Typography
              variant="h3"
              component="h4"
              sx={{
                fontSize: { xs: "1.2rem", sm: "2rem", md: "2rem" },
                fontWeight: 700,
                letterSpacing: "-0.025em",
                color: "#0F172A",
                lineHeight: 1.2,
              }}
            >
              openChow: Buy a Meal Online. Leave It on the Counter.
            </Typography>

            <Box sx={{ textAlign: "start" }}>
              <Typography
                variant="body1"
                sx={{ mt: 3, color: "#334155", maxWidth: "90%" }}
              >
                openChow, from our subsidiary openChow LTD, lets you sponsor a
                meal online. A local vendor (a “MamaPut”) adds it to their
                street chalkboard, and anyone who needs it can walk up, point to
                the board, and eat for free. No dignity compromised.
              </Typography>

              <Typography sx={{ color: "#334155" }}>
                Sponsor a meal from as little as ₦1,200. No account needed.
              </Typography>
            </Box>

            <Box sx={{ mt: 4, display: "flex" }}>
              <StorefrontOutlinedIcon
                sx={{ fontSize: "1.2rem", color: "#AB6A32", mr: 2 }}
              />
              <Typography sx={{ color: "#334155", maxWidth: "90%" }}>
                Money goes directly to verified local vendors, no middlemen
              </Typography>
            </Box>

            <Box sx={{ mt: 2, display: "flex" }}>
              <VolunteerActivismOutlinedIcon
                sx={{ fontSize: "1.2rem", color: "#AB6A32", mr: 2 }}
              />
              <Typography sx={{ color: "#334155", maxWidth: "90%" }}>
                Works on smartphones and feature phones (USSD)
              </Typography>
            </Box>

            <Box sx={{ mt: 2, display: "flex" }}>
              <VisibilityOutlinedIcon
                sx={{ fontSize: "1.2rem", color: "#AB6A32", mr: 2 }}
              />
              <Typography sx={{ color: "#334155", maxWidth: "90%" }}>
                Every sponsorship is tracked and transparent
              </Typography>
            </Box>

            <Button
              variant="contained"
              href="https://openchow.ng"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                mt: 4,
                backgroundColor: "#AB6A32",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": { backgroundColor: "#8f5628" },
              }}
            >
              Fund a Meal on openChow
            </Button>
          </Box>
        </Grid>

        {/* IMAGE COLUMN */}
        <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
          <Box
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              width: "100%",
              aspectRatio: isMobile ? "4/3" : "16/9",
            }}
          >
            <img
              src={"openchow.JPG"}
              alt="openChow meal sponsorship"
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomeExports;
